const GOOGLE_LOGIN_ERROR = "GOOGLE_LOGIN_ERROR";
const GOOGLE_LOGIN_SUCCESS = "GOOGLE_LOGIN_SUCCESS";
const GOOGLE_LOGIN_TRIGGER = "GOOGLE_LOGIN_TRIGGER";
const GOOGLE_LOGIN_CONFIRM_REDIRECT = "GOOGLE_LOGIN_CONFIRM_REDIRECT";
const GOOGLE_LOGIN_VERIFY_CODE = "GOOGLE_LOGIN_VERIFY_CODE";
const GOOGLE_LOGOUT = "GOOGLE_LOGOUT";
const GOOGLE_LOGOUT_TRIGGER = "GOOGLE_LOGOUT_TRIGGER";

export {
  GOOGLE_LOGIN_ERROR,
  GOOGLE_LOGIN_SUCCESS,
  GOOGLE_LOGIN_TRIGGER,
  GOOGLE_LOGIN_CONFIRM_REDIRECT,
  GOOGLE_LOGIN_VERIFY_CODE,
  GOOGLE_LOGOUT,
  GOOGLE_LOGOUT_TRIGGER,
};
